import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

/**
 * Primary navigation action (save, edit, etc.) in the native nav bar.
 *
 * @example
 *   <button type="submit" form="event_form" data-controller="bridge--nav-button" data-bridge-title="Save">Save</button>
 */
export default class extends BridgeComponent {
  static component = "nav_button"

  connect() {
    super.connect()
    if (!this.enabled) return

    const title = this.bridgeElement.bridgeAttribute("title") || this.bridgeElement.title
    this.send("connect", { title }, () => {
      this.bridgeElement.click()
    })
  }
}
